import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Squash = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="squash"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.8057 16.0115C51.1523 16.0115 53.0546 14.1092 53.0546 11.7626C53.0546 9.41598 51.1523 7.51367 48.8057 7.51367C46.4591 7.51367 44.5568 9.41598 44.5568 11.7626C44.5568 14.1092 46.4591 16.0115 48.8057 16.0115Z"
        fill={fill}
      />
      <path
        d="M31.5722 16.1581C32.5791 16.1581 33.3954 15.3419 33.3954 14.3349C33.3954 13.328 32.5791 12.5117 31.5722 12.5117C30.5653 12.5117 29.749 13.328 29.749 14.3349C29.749 15.3419 30.5653 16.1581 31.5722 16.1581Z"
        fill={fill}
      />
      <path
        d="M59.0323 56.788H58.1379C59.0854 56.3564 59.6872 55.348 59.554 54.2599C57.4475 37.0661 55.4346 21.0503 55.4426 21.1138C55.1529 18.7896 53.0341 17.1401 50.7098 17.4296C50.7098 17.4296 46.1347 18.4108 40.4336 19.7448L31.7983 18.6729C30.7917 18.5468 29.8728 19.263 29.748 20.2703C29.6229 21.2775 30.3382 22.1956 31.3454 22.3206L40.3088 23.4334C40.5195 23.4596 40.7386 23.45 40.9589 23.398H44.5C39.8783 25.5776 40.8783 25.1796 40.8783 25.1796L34.4309 26.7368L27.8124 24.5278C27.7079 22.8796 26.2275 21.2084 24.0552 20.4836C21.4074 19.5998 18.7359 20.4563 18.0885 22.3965C17.441 24.3367 19.0625 26.626 21.7103 27.5096C23.7605 28.1939 25.824 27.8342 26.952 26.7365L32.834 28.6996C32.9159 29.8546 34.0092 30.6202 35.097 30.3575L42.6787 28.5265L44.5 28H45.5L46.2892 35.4946L42.206 41.7179C41.9486 42.1103 41.8092 42.5684 41.8044 43.038L41.6903 54.5338C41.6804 55.5341 42.272 56.399 43.1275 56.7882H3.93545V2.24361C3.93545 1.1568 3.05453 0.275879 1.96773 0.275879C0.880926 0.275879 0 1.15692 0 2.24361V58.7558C0 59.8426 0.880926 60.7235 1.96773 60.7235H59.0323C60.1191 60.7235 61 59.8424 61 58.7557C61 57.6689 60.1191 56.788 59.0323 56.788ZM45.1526 56.7879C45.9926 56.406 46.5817 55.5657 46.5915 54.5822L46.6985 43.8052L51.2225 36.91L52.4713 36.7544L54.6891 54.8557C54.7969 55.735 55.3587 56.4462 56.1099 56.7879H45.1526Z"
        fill={fill}
      />
      <path d="M27 35L15.4848 53L7 46.1724" stroke="#A0DBE8" strokeLinecap="round" />
      <path d="M26 40.5L22 46.5" stroke="#A0DBE8" strokeLinecap="round" />
    </svg>
  );
};
/* eslint-enable max-len */

Squash.defaultProps = {
  className: null,
};

Squash.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Squash;
